const servicesAndAssociatedCookies = {
    'Google Analytics': '_gat,_ga,_gid'
}

$(function () {
    window.addEventListener("uCentricsEvent", function (event) {
        handleUserCentricsEvent(event);
    });
});

// Hook into "consent_status" event
const handleUserCentricsEvent = (event) => {
    if (event.detail && event.detail.event === "consent_status") {
        let analyticsService = 'Google Analytics';
        let mapService = 'Google Maps';


        if (event.detail.hasOwnProperty(analyticsService)) {
            handleAnalyticsService(event, analyticsService);
        }

        if (event.detail.hasOwnProperty(mapService) && !event.detail[mapService]) {
            handleMapService();
        }

    }
};

const handleAnalyticsService = (event, analyticsService) => {
    let approved = event.detail[analyticsService];

    // Update Google Consent settings
    gtag("consent", "update", {
        analytics_storage: approved ? 'granted' : 'denied'
    });

    if (!approved) {
        // If cookie exists, expire it
        getAssociatedCookies(analyticsService).forEach(cookie => {
            if (getCookie(cookie)) {
                setCookieExpired(cookie);
            }
        });
    }
};


// Remove custom map scripts from site when consent is denied
const handleMapService = () => {
    const scriptIds = ["customMap", "infobox", "clustere"];

    scriptIds.forEach(id => {
        let scriptElement = document.getElementById(id);

        if (scriptElement) {
            scriptElement.parentNode.removeChild(scriptElement);
        }
    });
};

// Google Maps API Callback function
// Add custom map scripts to site when consent is granted
const addCustomMapScripts = () => {
    const scripts = {
        customMap: "/js/usercentrics/map.js",
        infobox: "/js/usercentrics/google.maps.infobox.js",
        clusterer: "/js/usercentrics/google.maps.markerclusterer.js"
    }

    for (var key in scripts) {

        if (document.getElementById(key)) {
            continue;
        }

        let head = document.getElementsByTagName('head')[0];

        let script = document.createElement('script');
        script.src = scripts[key];
        script.id = key;

        head.appendChild(script);
    }
}

window.addCustomMapScripts = addCustomMapScripts;

const getCookie = (cookieName) => {
    const name = cookieName + '=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    const firstName = 0;
    const firstChar = 0;
    const secondChar = 1;

    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];

        while (c.charAt(firstChar) === ' ') {
            c = c.substring(secondChar);
        }

        if (c.indexOf(name) === firstName) {
            this.unread = false;
            return c.substring(name.length, c.length);
        }
    }
};

const setCookieExpired = (cookieName) => {
    const today = new Date();
    const time = today.getTime();
    const cookieExpirationTime = time - 99999;
    const domainName = window.location.hostname;

    today.setTime(cookieExpirationTime);

    document.cookie = `${cookieName}='';path=/;expires=${cookieExpirationTime};domain=${domainName}`;
};

const getAssociatedCookies = (serviceName) => {
    return servicesAndAssociatedCookies[serviceName].split(',');
};

// Pushes data to UserCentrics data layer
const gtag = (args) => {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push(args);
};